export const langEnum = {
    us: "en-US",
    cn: "zh-CN",
    tw: "zh-TW",
    ko: "ko",
    ru: "ru",
    de: "de",
    es: "es",
};
